import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ActionSelect } from '../../Action'
import { BUTTON_HEIGHT_24 } from '../../Button'
import Text from '../../Text'
import { BirdviewCard, BirdviewCardBody } from '../BirdviewCard'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_CHART_ACTIONS,
  QA_NAME_DASHBOARD_BIRDVIEW_CHART_METRIC,
  QA_NAME_DASHBOARD_BIRDVIEW_CHART_PERIOD,
} from '../DashboardBirdview.constants.qa'

import {
  useBirdviewChartCardActions,
  useBirdviewChartCardControls,
} from './BirdviewChartCard.hooks'
import { getBirdviewChartContent } from './BirdviewChartCard.utils'
import { BirdviewChartControlSelect } from './BirdviewChartControlSelect'

import * as styles from './BirdviewChartCard.module.css'

// The controls sit outside the body to stay usable while the chart loads.
function BirdviewChartCard({
  chart,
  controls = EMPTY_OBJECT,
  dragHandleProps,
  rowSpan,
  section,
  title,
  onChangeControls,
  onCycleSize,
  onNavigate,
  onRemove,
}) {
  const { t } = useTranslation()

  const {
    handleSelectMetric,
    handleSelectPeriod,
    metric,
    metricOptions,
    metricValue,
    period,
    periodOptions,
  } = useBirdviewChartCardControls({
    chart,
    controls,
    rowSpan,
    onChangeControls,
  })
  const { actions, handleClickAction, handleOpen } =
    useBirdviewChartCardActions({
      chart,
      period,
      periodOptions,
      onChangeControls,
      onCycleSize,
      onNavigate,
      onRemove,
    })

  return (
    <BirdviewCard
      dragHandleProps={dragHandleProps}
      headerMenu={
        <ActionSelect
          actions={actions}
          controlProps={{
            buttonProps: {
              height: BUTTON_HEIGHT_24,
              qaName: QA_NAME_DASHBOARD_BIRDVIEW_CHART_ACTIONS,
            },
          }}
          onClickAction={handleClickAction}
        />
      }
      title={title}
    >
      <div className={styles.body}>
        <div className={styles.controls}>
          {period ? (
            <BirdviewChartControlSelect
              options={periodOptions}
              qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_PERIOD}
              value={period}
              onSelect={handleSelectPeriod}
            />
          ) : (
            <Text isSecondary className={styles.asOfNow}>
              {t(chart.asOfNowKey ?? 'DashboardBirdview.ChartAsOfNowKey')}
            </Text>
          )}
          {metric ? (
            <BirdviewChartControlSelect
              options={metricOptions}
              qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_METRIC}
              value={metric}
              onSelect={handleSelectMetric}
            />
          ) : null}
        </div>
        <BirdviewCardBody
          emptyKey={chart.emptyKey ?? 'DashboardBirdview.ChartEmptyStateKey'}
          state={section.state}
          onRetry={section.reload}
        >
          <div className={styles.chart}>
            {getBirdviewChartContent({
              chart,
              metric: metricValue,
              section,
              t,
              onOpen: handleOpen,
            })}
          </div>
        </BirdviewCardBody>
      </div>
    </BirdviewCard>
  )
}

export default BirdviewChartCard
